import * as RTabs from "@radix-ui/react-tabs";
import { Flex, Button } from "@radix-ui/themes";
import { useNavigate, useRouterState } from "@tanstack/react-router";
import { useGateValue } from "@statsig/react-bindings";
import { LuFilter } from "react-icons/lu";
import { PillTabsList } from "@/components/ui/PillTabsList";

export function MarketplaceTabs({
  onFiltersClick,
}: {
  onFiltersClick: () => void;
}) {
  const navigate = useNavigate();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const showFiltersButton = pathname !== "/marketplace/albums";

  const songsMarketplaceEnabled = useGateValue("songs_marketplace");

  // Beats / Sounds removed with the Creator Marketplace; their routes
  // redirect to Albums.
  const tabs = [
    { value: "/marketplace/albums", label: "Albums" },
    ...(songsMarketplaceEnabled
      ? [{ value: "/marketplace/songs", label: "Songs" }]
      : []),
  ];

  return (
    <RTabs.Root
      value={pathname}
      onValueChange={(to) => navigate({ to })}
      className="w-full"
    >
      <Flex
        className="w-full items-center gap-2 flex-wrap"
        direction={{ initial: "column", sm: "row" }}
      >
        <div className="flex-1 min-w-0 overflow-x-auto w-full sm:w-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          <PillTabsList tabs={tabs} />
        </div>
        {showFiltersButton && (
          <Button
            onClick={onFiltersClick}
            color="gray"
            radius="full"
            className="shrink-0 w-full sm:w-auto"
          >
            <LuFilter className="text-[16px]" />
            Filters
          </Button>
        )}
      </Flex>
    </RTabs.Root>
  );
}
